import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const CONTAINER_BORDER_COLOR = "transparent";
const IMAGE_WIDTH = 80;

const horizontalStyle = () => {
  const { borderWidth2, colorText, colorTextMedium, space05, space2, space4, space6 } = theme();

  return StyleSheet.create({
    container: {
      flexDirection: "row",
      marginVertical: space4,
      paddingHorizontal: space6,
      width: "100%",
    },
    item: {
      marginHorizontal: space2 / 2,
      textAlign: "left",
      width: IMAGE_WIDTH + borderWidth2 * 2,
    },
    selectedText: {
      color: colorText,
    },
    text: {
      color: colorTextMedium,
      paddingLeft: space05,
    },
  });
};

const verticalStyle = () => {
  const { colorBgBase, colorText, colorTextMedium, space4 } = theme();

  return StyleSheet.create({
    container: {
      backgroundColor: colorBgBase,
      flexDirection: "column",
    },
    item: {
      marginBottom: space4,
    },
    selectedText: {
      color: colorText,
      textDecorationLine: "underline",
      textDecorationStyle: "solid",
    },
    text: {
      color: colorTextMedium,
    },
  });
};

const imageStyle = () => {
  const { borderRadius3, borderWidth2, colorText, space1 } = theme();

  return StyleSheet.create({
    active: {
      borderColor: colorText,
    },
    container: {
      borderColor: CONTAINER_BORDER_COLOR,
      borderRadius: borderRadius3,
      borderWidth: borderWidth2,
      marginBottom: space1,
      width: IMAGE_WIDTH + borderWidth2 * 2,
    },
    image: {
      borderRadius: borderRadius3 - borderWidth2,
      height: IMAGE_WIDTH,
      width: IMAGE_WIDTH,
    },
  });
};

export { horizontalStyle, verticalStyle, imageStyle };
